import api from './api';

// --- Interfaces ---
export interface Estado {
  id: number;
  sigla: string;
  nome: string;
}

export interface Municipio {
  id: number;
  nome: string;
  nome_original: string;
}

export interface Bairro {
  id: number;
  nome: string;
  nome_original: string;
}

// --- Interfaces para dashboard ---
export interface PopularDashboardResponse {
  incorporadoras: { id: string; nome: string }[];
  segmentos: { id: string; nome: string }[];
  lazer: { id: string; nome: string }[];
  infraestrutura: { id: string; nome: string }[];
  seguranca: { id: string; nome: string }[];
  fase_empreendimento: { id: string; nome: string }[];
}

export interface EmpreendimentoMetaResponse {
  pavimentos_min: number;
  pavimentos_max: number;
  elevadores_min: number;
  elevadores_max: number;
  torres_min: number;
  torres_max: number;
  ofertadas_min: number;
  ofertadas_max: number;
  vendidas_min: number;
  vendidas_max: number;
  perc_vendido_min: number;
  perc_vendido_max: number;
  estoque_min: number;
  estoque_max: number;
  perc_estoque_min: number;
  perc_estoque_max: number;
  vagas_min: number;
  vagas_max: number;
}

// --- Funções para a API ---
export const getFiltrosSelects = async (): Promise<PopularDashboardResponse> => {
  try {
    const { data } = await api.get("/popular-dashboard/");
    return {
      incorporadoras: data.incorporadoras.map((i: any) => ({ id: i.id, nome: i.nome })),
      segmentos: data.segmentos.map((s: any) => ({ id: s.id, nome: s.nome })),
      lazer: data.lazer.map((l: any) => ({ id: l.id, nome: l.nome })),
      infraestrutura: data.infraestrutura.map((i: any) => ({ id: i.id, nome: i.nome })),
      seguranca: data.seguranca.map((s: any) => ({ id: s.id, nome: s.nome })),
      fase_empreendimento: data.fase_empreendimento.map((f: any) => ({ id: f.id, nome: f.nome })),
    };
  } catch (error) {
    console.error("Erro ao buscar filtros de selects:", error);
    throw error;
  }
};

export const getEmpreendimentoMeta = async (): Promise<EmpreendimentoMetaResponse> => {
  try {
    const { data } = await api.get("/empreendimento-meta/");
    return data;
  } catch (error) {
    console.error("Erro ao buscar ranges:", error);
    throw error;
  }
};

export const getEstados = async (): Promise<Estado[]> => {
  try {
    const { data } = await api.get('/ufs-base'); // ajustei o endpoint
    // Retorna apenas o nome e id
    return data.map((e: any) => ({ id: e.id, sigla: e.sigla, nome: e.nome }));
  } catch (error) {
    console.error('Erro ao buscar estados:', error);
    throw error;
  }
};

export const getMunicipios = async (ufId: number): Promise<Municipio[]> => {
  try {
    const { data } = await api.get(`/municipios-base/por_uf?uf=${ufId}`);
    return data.map((m: any) => ({ id: m.id, nome: m.nome, nome_original: m.nome_original }));
  } catch (error) {
    console.error(`Erro ao buscar municípios da UF ${ufId}:`, error);
    throw error;
  }
};

export const getBairros = async (municipioId: number): Promise<Bairro[]> => {
  try {
    const { data } = await api.get(`/bairros-base/por_municipio?municipio=${municipioId}`);
    return data.map((b: any) => ({ id: b.id, nome: b.nome, nome_original: b.nome_original }));
  } catch (error) {
    console.error(`Erro ao buscar bairros do município ${municipioId}:`, error);
    throw error;
  }
};

